// RouteDailySingleList.js
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Button, IconButton, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ResponseAlert from '../message/ResponseAlert';
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppNumber, AppWord, AppObject, TableColumnType } from '../../model/AppConst';
import { LIST_ROUTE_DAILY } from './RouteDailyGql';
import { useLazyQuery } from '@apollo/client';

const RouteDailySingleListContainer = styled(Box)({
	flexGrow:1, display:'flex', flexDirection:'column'
});

const HeaderBox = styled(Box)({
    display: 'flex',
    height: AppNumber.HeaderToolBoxHeight,
    padding: AppNumber.SmallBoxPadding,
    alignItems: 'center',
});

const TabBox = styled(Box)({
    flexGrow:1,
    textAlign: 'right', display: 'flex', alignItems: 'center', paddingLeft: 20
});

const TableColumns = [
    { id: 'vehPlates', label: '차량번호', width: 110, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },    
    { id: 'totalDist', label: '총 주행거리(Km)', width: 120, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'secondsRun', label: '운행시간', width: 100, show: true, option:{align: 'right', print:(r,i,v)=>{return ValueUtil.formatDuration(v)}} },
    { id: 'avgSpeed', label: '평균속도', width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'maxSpeed', label: '최고속도', width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    // { id: 'hhmmFrom', label: '운행시작', width: 90, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    // { id: 'hhmmTill', label: '운행종료', width: 90, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    // { id: 'positionCount', label: '위치보고횟수', width: 100, show: true, option:{align: 'right', type: TableColumnType.INTEGER} },
    { id: 'termId', label: '단말기번호', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'custName', label: '업체명', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
];

export default function RouteDailySingleList({
    tabSelector,
	maxHeight,
	maxWidth,
}) {
    const [routeDate, setRouteDate] = useState(ValueUtil.getYmdText());
    const [records, setRecords] = useState([]);
    const [search, setSearch] = useState('');
    const [responseAlert, setResponseAlert] = useState(null);

    // ##### Call GraphQL to get List #####
    const [getRouteDailyList, responseList] = useLazyQuery(LIST_ROUTE_DAILY, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => {setResponseAlert({open:true, error: error, title: "1일 주행거리 조회 오류"})}
    });

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.routeDailyList) {
            setRecords(data.routeDailyList);
        }
    };

    const onChangeSearch = (event) => {
        setSearch(event.target.value);
    };

    const onChangeDate = (event) => {
        setRouteDate(event.target.value);
    };

    const onClickGetList = () => {
        if(routeDate) {
            getRouteDailyList({variables: {dateFrom: routeDate, dateTill: routeDate}});
        }
    };

    return(
        <RouteDailySingleListContainer>
            <HeaderBox>
                <span>조회날짜 &nbsp;</span>
                <TextField id='routeDate' type='date' value={routeDate} size={AppWord.SMALL} onChange={onChangeDate} />
                &nbsp;
                <Button size={AppWord.SMALL}
                    onClick={onClickGetList}
                    variant='contained' color="primary"
                    disabled={!Boolean(routeDate)}
                >
                    조회
                </Button>
                &nbsp;&nbsp;
				<FormControl variant='outlined' size={AppWord.SMALL}>
					<InputLabel htmlFor="search-RouteDailySingle-list" style={{backgroundColor:'white'}}>검색</InputLabel>
					<OutlinedInput id="search-RouteDailySingle-list" onChange={onChangeSearch}
						value={search}
						disabled={records.length === 0}
						size={AppWord.SMALL}
						endAdornment={
							Boolean(search) ?
							<InputAdornment position={AppWord.END}>
								<IconButton
								onClick={()=>{setSearch('')}}
								size={AppWord.SMALL}
								edge={AppWord.END}
								>
									<ClearIcon />
								</IconButton>
							</InputAdornment>
							:
							null
						}
					/>
				</FormControl>
                <TabBox>
                    {tabSelector}
                </TabBox>
            </HeaderBox>
            <FlexyTable
                name="route_daily_single_list"
                uniqueKey="vehId"
                columns={TableColumns}
                records={records}
                search={search}
                tools={[]}
            />
            <ResponseAlert open={responseAlert ? responseAlert.open : false}
                alertData={responseAlert}
                onClose={() => {setResponseAlert(null)}}/>
        </RouteDailySingleListContainer>
    );

}
